var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUavFDl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3125 13.2891C2.3125 13.1016 2.39062 12.9375 2.53125 12.7656L9.82031 3.73438C10.3828 3.03906 11.2656 3.49219 10.9453 4.34375L8.5625 10.75H13.0938C13.4375 10.75 13.6875 10.9844 13.6875 11.3125C13.6875 11.4922 13.6172 11.6562 13.4766 11.8359L6.17969 20.8672C5.61719 21.5547 4.73438 21.1016 5.05469 20.25L7.4375 13.8516H2.90625C2.5625 13.8516 2.3125 13.6094 2.3125 13.2891Z",
    fill: "#E50019",
    fillOpacity: 0.75
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUavFDl);
export default __webpack_public_path__ + "static/media/uav_f_dl.07c361f0af7f1e71b62483e571e1ca5f.svg";
export { ForwardRef as ReactComponent };